import { render, staticRenderFns } from "./VueStickey.vue?vue&type=template&id=0e8cd70b&"
import script from "./VueStickey.vue?vue&type=script&lang=js&"
export * from "./VueStickey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports